import { WEB_FORM_AUTOFILL_FIELD } from '@/utils/locale';
import { ENTRY_POINT } from '@/types/entryPoints';

type WebformLinkType = undefined | string | Record<string, string | { url: string, fieldIdMap: Record<string, string> }>;

const DRIVER_WEB_FORM_MAP: WebformLinkType = {
  th: {
    live: {
      // HC 跟下面的Food共用webform url
      [ENTRY_POINT.DriverAPPHelpCenter]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      // Food
      [ENTRY_POINT.DriverAPPFoodOrderPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPReportIssuePage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPReportFoodIssuePage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOngoingOrderPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderOngoingPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      // SPXi
      [ENTRY_POINT.DriverAPPSPXOrderPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderOngoingPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPReportSPXiIssuePage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
    },
    uat: {
      // 仅用于测试
      [ENTRY_POINT.DriverAPPHelpCenter]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPReportIssuePage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPReportFoodIssuePage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOngoingOrderPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderOngoingPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPSPXOrderPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderOngoingPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPReportSPXiIssuePage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
    },
    test: {
      // 仅用于测试
      [ENTRY_POINT.DriverAPPHelpCenter]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPReportIssuePage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPReportFoodIssuePage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOngoingOrderPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderOngoingPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPFoodOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/455a6da86bc14cc2b72eededaf948023',
      [ENTRY_POINT.DriverAPPSPXOrderPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderOngoingPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderDetailsPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPSPXiOrderHistoryPage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
      [ENTRY_POINT.DriverAPPReportSPXiIssuePage]: 'https://help.shopee.co.th/portal/webform/682ca5760330426c8015cad46fe1b749',
    },
    dev: 'https://help.uat.shopee.co.th/portal/webform/b0018ddd3bc547399f64912eb07157a3', // 保持旧逻辑，使用uat链接
  },
  vn: {
    live: {
      [ENTRY_POINT.ShopeeFoodVNDriverHC]: {
        url: 'https://help.cs.shopeefood.vn/portal/webform/2caeccd017264b68978b2eca5c47d4e4',
        fieldIdMap: {
          [WEB_FORM_AUTOFILL_FIELD.userType]: '',
          [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '',
        },
      },
    },
    uat: {
      [ENTRY_POINT.ShopeeFoodVNDriverHC]: {
        url: 'https://help.cs.uat.shopeefood.vn/portal/webform/9e500f7d067b4c08bb194a92f877b9b8',
        fieldIdMap: {
          [WEB_FORM_AUTOFILL_FIELD.userType]: '',
          [WEB_FORM_AUTOFILL_FIELD.enquiryType]: '',
        },
      },
    },
  },
  my: {
    live: 'https://help.shopee.com.my/portal/webform/b7a7ff2afd484f1dbddb3a922c7e90e7',
    uat: 'https://help.uat.shopee.com.my/portal/webform/5df89a77cbe746f9909b4f495ff68173',
    test: 'https://help.uat.shopee.com.my/portal/webform/5df89a77cbe746f9909b4f495ff68173', // 保持旧逻辑，使用uat链接
    development: 'https://help.uat.shopee.com.my/portal/webform/5df89a77cbe746f9909b4f495ff68173', // 保持旧逻辑，使用uat链接
  },
  id: {
    live: 'https://help.shopee.co.id/portal/webform/888adc066bf3426a8c70227470281818',
    uat: 'https://help.uat.shopee.co.id/portal/webform/34c63252816b479d93170b993d10302b',
    test: 'https://help.test.shopee.co.id/portal/webform/ecb9549cac9e47f7a191e9b2dbdd9105',
    development: 'https://help.test.shopee.co.id/portal/webform/ecb9549cac9e47f7a191e9b2dbdd9105', // 保持旧逻辑，使用test链接
  },
}[COUNTRY]?.[ENVIRONMENT];

export function getDriverWebformUrl(entryPoint: number): string {
  // 未配置
  if (!DRIVER_WEB_FORM_MAP) {
    return '';
  }
  // 仅配置单个url
  if (typeof DRIVER_WEB_FORM_MAP === 'string') {
    return DRIVER_WEB_FORM_MAP || '';
  }
  // 按entry pont配置
  const node = DRIVER_WEB_FORM_MAP[entryPoint];
  if (!node || typeof node === 'string') {
    return node || '';
  }
  return node?.url || '';
}
